import router from '@/router'
export const namespaced = true

const handler = err => err ? 'ok' : 'ok'

export const state = {
  organization: null,
  manager: null,
  bid_direction: 0,
  period: 0,
  status: []
}

export const getters = {
  organization (state) {
    return state.organization
  },
  manager (state) {
    return state.manager
  },
  bid_direction (state) {
    return state.bid_direction
  },
  period (state) {
    return state.period
  },
  status (state) {
    return state.status
  }
}

export const mutations = {
  SET_ORGANIZATION (state, org) {
    state.organization = org
  },
  SET_MANAGER (state, man) {
    state.manager = man
  },
  SET_BID_DIRECTION (state, dir) {
    state.bid_direction = dir
  },
  SET_PERIOD (state, per) {
    state.period = per
  },
  SET_STATUS (state, status) {
    state.status = status
  }
}

export const actions = {
  setOrganization ({ commit, dispatch }, org) {
    commit('SET_ORGANIZATION', org)
    router.push({ name: 'procedures' }).catch(handler)
    dispatch('procedure/load', null, { root: true })
  },
  setManager ({ commit, dispatch }, man) {
    commit('SET_MANAGER', man)
    router.push({ name: 'procedures' }).catch(handler)
    dispatch('procedure/load', null, { root: true })
  },
  setBidDirection ({ commit, dispatch }, dir) {
    commit('SET_BID_DIRECTION', dir)
    router.push({ name: 'procedures' }).catch(handler)
    dispatch('procedure/load', null, { root: true })
  },
  setPeriod ({ commit, dispatch }, per) {
    commit('SET_PERIOD', per)
    dispatch('procedure/load', null, { root: true })
  },
  setStatus ({ commit, dispatch }, sta) {
    commit('SET_STATUS', sta)
    router.push({ name: 'procedures' }).catch(handler)
    dispatch('procedure/load', null, { root: true })
  }
}
